import React, { Fragment } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextInput from 'Components/Forms/Elements/TextInput';
import bemit from 'Functions/bemit';
export default function CustomerPicking(props) {
  const customers = (props.cutomer_search_result || []).map(function (customer) {
    let output = /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__row",
      key: customer.id
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, customer.lastname), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, customer.firstname), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, customer.login), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: e => props.selectCustomer(customer.id)
    }, "Choisir ce client", props.loader)));
    return output;
  });
  const output = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    onChange: props.handleChange,
    value: props['customer_searched'],
    name: "customer_searched",
    label: "Entrez l'email du client",
    status: props.status
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-flat-btn', ['primary']),
    onClick: props.searchCustomer
  }, "Chercher le client", props.loader))), /*#__PURE__*/React.createElement("div", {
    className: "dashboard-wrapper u-margin-top-20"
  }, /*#__PURE__*/React.createElement("div", {
    className: bemit('c-dashboard', ['head'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell"
  }, "Nom"), /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell"
  }, "Pr\xE9nom"), /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell"
  }, "Adresse mail"), /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell"
  }))), /*#__PURE__*/React.createElement("div", {
    className: bemit('c-dashboard')
  }, customers)));
  return output;
}
